import React from 'react'

import Result from './Result'

import style from './Search.module.scss'

const Results = ({
  engine,
  microcopy
}) => (
  <> 
    { (engine.state.results && engine.state.results[0]) ? (
      <div className={ style.wrapper }>
        <ul className={style.results}>
          { engine.state.results.map((result, index) => (
            <Result
              key={index} 
              result={result} 
              index={index} 
              engine={engine}
              microcopy={microcopy} />
          )) }
        </ul>
      </div>
    ) : (
      <div className={ style.wrapper }>
        <ul className={style.results}>
          <li className={style.result}>
            <a data-example>
              <strong>Upload file</strong>
              <span className={style.type} data-type='example'>
                { microcopy.text(`reference.parameter_details.example`) }
              </span>
              <span className={style.description}></span>
            </a>
          </li>
          <li className={style.result}>
            <a data-example>
              <strong>Download file</strong>
              <span className={style.type} data-type='example'>
                { microcopy.text(`reference.parameter_details.example`) }
              </span>
              <span className={style.description}></span>
            </a>
          </li>
          <li className={style.result}>
            <a data-example>
              <strong>Webhooks</strong>
              <span className={style.type} data-type='example'>
                { microcopy.text(`reference.parameter_details.example`) }
              </span>
              <span className={style.description}></span>
            </a>
          </li>
          <li className={style.result}>
            <a data-example>
              <strong>Create template</strong>
              <span className={style.type} data-type='example'>
                { microcopy.text(`reference.parameter_details.example`) }
              </span>
              <span className={style.description}></span>
            </a>
          </li>
        </ul>
      </div>
    )}
  </>
)

export default Results